
import React from "react";
import "./MoveInCleaningService.css";

const MoveInCleaningService = () => {
  return (
    <div className="move-in-cleaning-container">
      <h1>Start Fresh in a Spotless Home</h1>
      <p>
        Moving into a new home should be exciting, not stressful. Our Move-In Cleaning
        service ensures your space is fresh, sanitized, and truly ready for you to settle in.
        We eliminate any traces left behind by previous occupants—from dust in corners to
        hidden grime in cabinets—so you can begin this new chapter in a clean and healthy environment.
      </p>

      <h2>What’s Included:</h2>
      <ul>
        <li>Full surface disinfection (kitchen, bathroom, living areas)</li>
        <li>Inside and outside of cabinets and drawers</li>
        <li>Wiping baseboards, light switches, and door handles</li>
        <li>Cleaning kitchen appliances (exterior)</li>
        <li>Vacuuming and mopping all floors</li>
        <li>Dusting ceiling fans and vents</li>
      </ul>

      <h2>Why Choose Us for Move In Cleaning?</h2>
      <ul>
        <li>🧽 <strong>Fresh Start Guarantee</strong> – We prepare your new home with the same care as if it were our own.</li>
        <li>🌿 <strong>Healthy & Safe Environment</strong> – We use eco conscious products that are safe for children and pets.</li>
        <li>📅 <strong>Timely Service</strong> – We’re ready when you are, even on short notice.</li>
        <li>🤝 <strong>Seamless Coordination</strong> – We work closely with you or your realtor for a smooth transition.</li>
        <li>💬 <strong>Reliable, Friendly Communication</strong> – You'll always know what to expect, every step of the way.</li>
      </ul>
    </div>
  );
};

export default MoveInCleaningService;
